import { render, staticRenderFns } from "./FailedPaymentsIcon.vue?vue&type=template&id=77595b8d&"
import script from "./FailedPaymentsIcon.vue?vue&type=script&lang=js&"
export * from "./FailedPaymentsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports